(function () {
    var headroom, myElement;

    myElement = document.querySelector("header");

    headroom = new Headroom(myElement, {
        offset: 150,
        classes: {
            notTop: "header--not-top",
        },
    });

    headroom.init();

    document.addEventListener("DOMContentLoaded", function () {
        var drawer, menu, navigator, pl1;

        menu = new MmenuLight(document.querySelector("#menu"), "all");
        navigator = menu.navigation();
        drawer = menu.offcanvas({
            position: "right",
        });

        document.querySelector(".navbar-toggler").addEventListener("click", function (evnt) {
            evnt.preventDefault();
            return drawer.open();
        });

        $(".scrollbar-inner").scrollbar();

        /* $(window).resize(function () {
            $(".navbar-nav li").on("mouseenter mouseleave", function (e) {
                var docH, docW, elOff, elm, isEntirelyVisible, l, w;
                if ($("ul", this).length) {
                    elm = $("ul:first", this);
                    elOff = elm.offset();
                    l = elOff.left;
                    w = elm.width();
                    console.log("elOff.left - " + l);
                    console.log("elm.width() - " + w);
                    docH = $(".container").height();
                    docW = $(".container").width();
                    console.log("container.width() - " + docW);
                    isEntirelyVisible = l + w - 500 <= docW;
                    if (!isEntirelyVisible) {
                        $(this).find(".dropdown-menu").addClass("dropdown-menu-right");
                    } else {
                        $(this).find(".dropdown-menu").removeClass("dropdown-menu-right");
                    }
                }
            });
        }); */

        pl1 = 0;
        $(".navbar-nav li").on("mouseenter mouseleave", function (e) {
            var docW, elOff, elm, isEntirelyVisible, l, w;

            if ($(this).parent().hasClass("navbar-nav")) {
                pl1 = $(this).position().left;
            }

            if ($("ul", this).length) {
                elm = $("ul:first", this);
                elOff = elm.position();
                l = elOff.left;
                w = elm.width();
                docW = $(".container").first().width();
                isEntirelyVisible = pl1 + l + w <= docW;

                if (!isEntirelyVisible) {
                    $(this).find(".dropdown-menu").addClass("dropdown-menu-right");
                } else {
                    $(this).find(".dropdown-menu").removeClass("dropdown-menu-right");
                }
            }
        });

        if ($(".slider-img").length > 0) {
            return $(".slider-img").each(function (i, e) {
                var $this;

                $this = $(e);

                return $this.slick({
                    infinite: true,
                    dots: false,
                    arrows: true,
                    dotsClass: "slider-dots",
                    customPaging: function (slider, i) {
                        if (slider.slideCount === 1 || slider.slideCount === slider.options.slidesToShow) {
                            return false;
                        }
                        return "<a class='slider-dots-item'></a>";
                    },
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    prevArrow: '<div class="slider-control slider-control-prev"></div>',
                    nextArrow: '<div class="slider-control slider-control-next"></div>',
                    speed: 500,
                    fade: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    useCSS: false,
                    cssEase: "linear",
                });
            });
        }

        var usernameUri = $('[data-username-uri]').data('username-uri');
        var userName = window.sessionStorage.getItem('user-name') || '';
        if (userName && userName != 'undefined') {
            // Info is cached
            $('[role=username]').html(userName);
            $('[role=if-not-authenticated]').hide();
            $('[role=if-authenticated]').removeClass('d-none');
        } else {
            $.ajax(usernameUri, {
                type: 'GET',
                success: function (data) {
                    if (data.name) {
                        window.sessionStorage.setItem('user-name', data.name);
                        $('[role=username]').html(data.name);
                        $('[role=if-not-authenticated]').hide();
                        $('[role=if-authenticated]').removeClass('d-none');
                    }
                }
            });
        }

        $('button[data-type="btn-review"]').click(function () {
            var reviewUri = $(this).closest('.participants-list').data('action-review');
            var reviewedStatus = $(this).data('status');
            var member = $(this).data('member');
            var $that = $(this);
            var $other = $(this).siblings('button[data-status="' + (reviewedStatus === 'YES' ? 'NO' : 'YES') + '"]');
            // Hide review buttons during AJAX request
            $(this).hide();
            $other.hide();
            $.ajax({
                url: reviewUri,
                data: {
                    'tx_lbcal_pievents[member]': member,
                    'tx_lbcal_pievents[status]': reviewedStatus === 'YES' ? 1 : 0,
                    'tx_lbcal_pievents[isAjax]': 1
                }
            }).done(function (ret) {
                if (ret.success) {
                    if ($that.hasClass('btn-outline-success')) {
                        $that.removeClass('btn-outline-success').addClass('btn-success');
                    } else {
                        $that.removeClass('btn-outline-danger').addClass('btn-danger');
                    }
                    $that.attr('disabled', 'disabled');
                    $that.show();
                    $that.closest('tr').removeClass('table-success table-danger table-warning').addClass(reviewedStatus === 'YES' ? 'table-success' : 'table-danger');
                }
            });
        });
    });
}).call(this);
